import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'antd';
import AuthLayout from '../AuthLayout/AuthLayout';
import AuthContainer from '../../containers/AuthContainer';

const AuthDropdown = ({ children, register, requestAccess, layout, isOpen, onVisibleChange, ...rest }) => {
  const [visible, setVisible] = useState(isOpen);
  const Layout = layout;

  useEffect(() => {
    setVisible(isOpen);
  }, [isOpen]);

  const onOpenChange = useCallback((state) => {
    setVisible(state);
    onVisibleChange && onVisibleChange(state);
  }, [onVisibleChange]);

  const menu = useMemo(() => (
    <Layout setVisible={setVisible}>
      <AuthContainer visible={visible} register={register} requestAccess={requestAccess} {...rest}/>
    </Layout>
  ), [visible, register, requestAccess, rest]);

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" visible={visible}
      onVisibleChange={onOpenChange}>
      <div className={'cursor-pointer'}>
        {children}
      </div>
    </Dropdown>
  );

};

export default memo(AuthDropdown);

AuthDropdown.propTypes = {
  layout: PropTypes.any,
  children: PropTypes.any,
  register: PropTypes.bool,
  isOpen: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  useCaptcha: PropTypes.bool,
  requestAccess: PropTypes.bool
};

AuthDropdown.defaultProps = {
  children: 'Acceder',
  layout: AuthLayout,
};
